import React from "react";

import { UserPill } from "@/components";
import { SearchQuery, User } from "@/gql/generated/graphql";

export const ResultsUsers = ({
  users = [],
}: {
  users: NonNullable<SearchQuery["search"]>["users"];
}) => {
  if (!users.length) {
    return (
      <div>
        <h3>Studios</h3>
        <p>No studio results.</p>
      </div>
    );
  }

  return (
    <div>
      <h3>Studios</h3>
      {users.map((user) => (
        <UserPill user={user} key={user.id} small />
      ))}
    </div>
  );
};
